module.exports = __webpack_public_path__ + "static/23-24a4054aaa92201c79665b8cfdb31f6d.png";